module.exports = __webpack_public_path__ + "img/night sparrows unagi stand.0297c9dc.png";